<template>
  <filter-speed-template>
    <v-row>
      <v-checkbox
        v-model="Status"
        label="Pendente"
        class="mr-3 body"
      />
      <input-radio
        v-model="payload.Interval"
        :options="IntervalOptions"
        row
      />
    </v-row>
  </filter-speed-template>
</template>

<script>
import FilterSpeedTemplate from '@/app/arch/components/crud/components/FilterSpeedTemplate.vue';
import FilterMixin from '@/app/arch/components/crud/crud-mixins/FilterMixin';

export default {
  name: 'ConciliationSpeedFilter',
  components: { FilterSpeedTemplate },
  mixins: [FilterMixin],
  data: () => ({
    payload: {
      Interval: '',
      Status: '',
    },
    Status: '',
    IntervalOptions: [
      {
        value: 'Monthly',
        label: 'Mensal',
        color: 'primary',
      },
      {
        value: 'Bimonthly',
        label: 'Bimestral',
        color: 'primary',
      },
      {
        value: 'Quarterly',
        label: 'Trimestral',
        color: 'primary',
      },
    ],
  }),
  watch: {
    Status: {
      handler(value) {
        if (this.isBool(value)) {
          if (value) {
            this.payload.Status = 'Pending';
          } else {
            this.payload.Status = '';
          }
          this.filter();
        }
      },
    },
    'payload.Interval': {
      handler(value) {
        if (value) {
          this.filter();
        }
      },
    },
  },
  methods: {
    isBool(value) {
      return typeof value === 'boolean';
    },
  },
};
</script>
